import { DOCUMENT_EXTENSIONS, DOCUMENT_REQUEST_LOCATION, IDocumentRequest } from '../../../models/utilities/document-request';
import { API_METHODS } from '../../../models/utilities/type-models';
import { ApiEndpoints } from '../../../utils/app-constants';
import { toCondensedDateTimeSeconds } from '../../../utils/date-utils';

export class MetricsDeliveryExport implements IDocumentRequest {

    public filename : string = '';
    public fileExtension : DOCUMENT_EXTENSIONS = 'xlsx';
    public openInTab : boolean = false;
    public url : string = ''; 
    public reportLocation : DOCUMENT_REQUEST_LOCATION = 'api';
    public methodType : API_METHODS = 'GET';

    constructor() {
        
        this.url = ApiEndpoints.PRODUCTION_METRICS_SHIPMENTS_EXPORT;
        this.filename = `PlanningShipments_${ toCondensedDateTimeSeconds(new Date()) }`;

    }

}
